import React, { Component } from 'react';
import { Row, Col, Input, Form, Icon } from 'antd';

export default class Captcha extends Component {
    constructor(props) { super(props); }

    render() {
        switch(this.props.request.status) {
            default: return null;

            case 'pending': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <div style={{ dispaly: 'inline-block', color: 'rgb(205, 205, 205)', fontWeight: 'bold' }}>
                                <Icon type='loading' style={{ fontSize: '20px' }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            );

            case 'success': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <img
                                src={`data:image/png;base64,${this.props.data}`}
                                style={{
                                    width: '200px',
                                    height: '40px',
                                    filter: this.props.readyToSubmit ? 'grayscale(0%)' : ''
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            );

            case 'failure': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col>
                            <div style={{ dispaly: 'inline-block', color: 'rgb(195, 195, 195)' }}>
                                <Icon type='close-circle-o' style={{ fontSize: '16px' }} />
                                <span style={{ marginLeft: '4px', fontStyle: 'italic' }}>
                                    {'Unable to load code.'}
                                </span>
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }
    }
}
